import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import BreadcrumbNavStore from './store';

const styles = require('./index.less');

const BreadcrumbNav = ({ store }) => {
  store.use();

  const renderItem = (item, index) => {
    if (item.path || item.href) {
      return (
        <Link
          onClick={() => {
            store.onNavClick(item);
          }}
        >
          <span style={{ color: index === store.navItems.length - 1 ? 'rgb(214,182,111)' : '' }}>{item.label}</span>
        </Link>
      );
    }
    return (
      <span className={styles.text2} style={{ color: index === store.navItems.length - 1 ? 'rgb(214,182,111)' : '' }}>
        {item.label}
      </span>
    );
  };

  return (
    <div className={styles.breadcrumbNav}>
      <div className={styles.breadcrumbNavIcon} />
      <div className={styles.breadcrumbNavText}>
        {store.navItems?.length > 0 &&
          store.navItems.map((item, index) => (
            <React.Fragment key={item.label}>
              {renderItem(item, index)}
              {index < store.navItems.length - 1 && ' > '}
            </React.Fragment>
          ))}
      </div>
    </div>
  );
};

export default wrapStore(BreadcrumbNav, BreadcrumbNavStore);
